import { useTypewriter } from "./hooks/ChatHooks";

export const TypewriterText=({ text, speed, onReady, scrollBottom}: { text: string; speed: number, onReady:() => void, scrollBottom: () => void} )=>{
    const displayText = useTypewriter(text, speed, onReady, scrollBottom)
    return <>{displayText}</>
}